import React from 'react'

import styled from 'styled-components'
import { SvgSpinner } from '@chilipiper/icons/src/Spinner'

import { SpaceProps, SystemProps } from '../../new/theme'

import { Flex } from '../../new/core-components/box'
import { Icon } from '../icon'

type Props = SystemProps & {
  'data-test-id'?: string
  size?: SpaceProps
}

const AnimatedIcon = styled(Icon)`
  animation: spinner 1s linear infinite;

  @keyframes spinner {
    100% {
      transform: rotate(1turn);
    }
  }
`

/** @deprecated - Use the `Loader` component from `@chilipiper/design-system/src/new` instead */
export const Loader = (rootProps: Props) => {
  const {
    size,
    'data-test-id': dataTestId,
    ...props
  } = { width: '100%', height: '100%', size: 6, color: 'fg/brand', ...rootProps }
  return (
    <Flex alignItems='center' justifyContent='center' data-test-id={dataTestId} {...props}>
      <AnimatedIcon {...props} w={size} h={size} icon={SvgSpinner} />
    </Flex>
  )
}
